module.exports = __webpack_public_path__ + "static/media/Slide27.d18755bd.jpg";